export class AppraisalSurchargeCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCriteria() {
    return this.#http.get('/api/appraisal-surcharge-criteria-collection');
  }

  async createCriteria(body) {
    return this.#http.put('/api/appraisal-surcharge-criteria-collection', { create: [body] });
  }

  async editCriteria(body) {
    return this.#http.put('/api/appraisal-surcharge-criteria-collection', { update: body });
  }

  async deleteCriteria({ criteriaId }) {
    return this.#http.put('/api/appraisal-surcharge-criteria-collection', { remove: [criteriaId] });
  }
}
